<template>
	<core-send-email-notification
		@notification:sent="$emit('notification:sent')"
	/>
</template>

<script>
import CoreSendEmailNotification from "@/modules/core/components/CoreSendEmailNotification"

export default {
	components: {
		CoreSendEmailNotification
	}
}
</script>
